import React from 'react';

function About() {
    return (
        <div className="about-container p-8 max-w-4xl mx-auto pb-32">
            <h1 className="text-4xl font-bold mb-4">About EmoSync</h1>

            <div className="flex flex-wrap gap-3 mb-8">
                <a
                    href="https://dl.acm.org/doi/10.1145/3706598.3714122"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors text-sm"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    ACM Digital Library
                </a>
                <a
                    href={`${process.env.PUBLIC_URL}/emosync-paper-2025.pdf`}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center px-4 py-2 bg-gray-700 text-white font-medium rounded-lg hover:bg-gray-800 transition-colors text-sm"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-4 w-4 mr-2" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
                    </svg>
                    Paper (PDF)
                </a>
            </div>

            <div className="mb-8">
                <p className="text-base text-gray-600">
                    <a href="https://hyojinju.com/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 hover:underline">Hyojin Ju</a>
                    {' · '}
                    <a href="https://www.jungeunlee.me/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 hover:underline">Jungeun Lee</a>
                    {' · '}
                    <a href="https://ysw.kr/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 hover:underline">Seungwon Yang</a>
                    {' · '}
                    <a href="https://sites.google.com/view/jungseulok" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 hover:underline">Jungseul Ok</a>
                    {' · '}
                    <a href="https://www.inseokhwang.com/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 hover:underline">Inseok Hwang</a>
                </p>
                <p className="text-sm text-gray-500 mt-1">
                    <a href="https://cse.postech.ac.kr/" target="_blank" rel="noopener noreferrer" className="hover:text-blue-600 hover:underline">POSTECH, Dept. of CSE</a>
                </p>
            </div>

            <div className="space-y-8">
                <section>
                    <h2 className="text-3xl font-semibold mb-6">Project Overview</h2>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        EmoSync is an LLM-based agent that generates personalized analogical microaggression situations, facilitating users to personally resonate with a specific microaggression situation of another person. In modern societies where people of diverse backgrounds increasingly interact together, fostering affective empathy is crucial. EmoSync addresses the limitations of previous approaches that assumed presenting the same experience as-is would evoke the same emotion, which often fails when emotional responses differ across individuals.
                    </p>
                </section>

                <section>
                    <h2 className="text-3xl font-semibold mb-6">Research Context</h2>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        This project is based on our paper "Toward Affective Empathy via Personalized Analogy Generation: A Case Study on Microaggression" presented at CHI 2025: CHI Conference on Human Factors in Computing Systems. The research introduces a novel concept of generating personalized experiences using large language models (LLMs) to facilitate affective empathy between individuals despite their differences.
                    </p>
                </section>

                <section>
                    <h2 className="text-3xl font-semibold mb-6">Video Presentation</h2>
                    <div className="aspect-w-16 aspect-h-9">
                        <iframe
                            className="w-full h-[400px] rounded-lg"
                            src="https://www.youtube.com/embed/sT1gxhITWyU"
                            title="EmoSync: Toward Affective Empathy via Personalized Analogy Generation"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                            allowFullScreen
                        ></iframe>
                    </div>
                </section>

                <section>
                    <h2 className="text-3xl font-semibold mb-6">Research Methodology</h2>
                    <p className="text-lg text-gray-700 leading-relaxed">
                        EmoSync was designed and evaluated through a comprehensive 3-phased user study with over 100 participants. The study aimed to understand how personalized analogical microaggression situations can help users develop affective empathy for experiences different from their own.
                    </p>
                </section>

                <section className="mt-4 pt-4 border-t border-gray-200">
                    <a
                        href="./emosync-offline.zip"
                        download
                        className="text-sm text-gray-400 hover:text-gray-600 transition-colors"
                    >
                        Download offline version of this site
                    </a>
                </section>
            </div>
        </div>
    );
}

export default About; 